<p-card>
  <ng-template pTemplate="header">
    <div class="flex justify-between">
      <div class="p-card-title">{{report().incident.summary}}</div>

    </div>
  </ng-template>

  @if (!incomplete()) {
    <div>
      <app-dynamic-view [formFields]="witnessFormFields()" [formData]="report()"></app-dynamic-view>
    </div>
  }
  @if (incomplete()) {
    <div>
      <div class="alert alert-danger">
        <strong>Incomplete</strong>
        <p>
          This report was requested, but has not been completed.
        </p>
      </div>
    </div>
  }

</p-card>
